import { useEffect, useState, useContext } from "react";
import {PageTreeContext} from "../../context/pageTreeContext"
import { isNeitherNullNorUndefined } from "../../utils/functions";
import {basename} from "../../constants"





export default function Breadcrumbs(){

    const pageTreeContextValue = useContext(PageTreeContext);



    return (
        <div className=' breadcrumbsContainer '>
        {pageTreeContextValue.isBreadcrumbsVisible 
        &&   
        <nav className="flex breadcrumbs mb-3" aria-label="Breadcrumb">
        
        {isNeitherNullNorUndefined(pageTreeContextValue.pageNavigationInfo?.lerneinheitID)
            &&
            <ol className="inline-flex items-center space-x-1 md:space-x-3">
                <li className="inline-flex items-center">
                    <a href={basename + "/start"} className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                        <svg className="w-3 h-3 mr-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
                        </svg>
                    </a>
                </li>
                <li>
                    <div className="flex items-center">
                        <svg className="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                        </svg>
                        <a href={basename + "/lerneinheiten"} className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2 dark:text-gray-400 dark:hover:text-white">
                        Lerneinheiten
                        </a>
                    </div>
                </li>

                
                <li aria-current="page">
                    <div className="flex items-center">
                        <svg className="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                        </svg>
                        <a 
                            href={
                                isNeitherNullNorUndefined(pageTreeContextValue.pageNavigationInfo.lerneinheitID) 
                                ?
                                basename + "/lerneinheiten/page/" + pageTreeContextValue.pageNavigationInfo.lerneinheitID
                                :
                                ""} 
                            className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2 dark:text-gray-400 dark:hover:text-white">
                            {pageTreeContextValue.pageNavigationInfo.lerneinheitName}
                        </a>
                    </div>
                </li>

                {pageTreeContextValue.pageNavigationInfo.subChapterID !== null 
                    &&
                    <li aria-current="page">
                        <div className="flex items-center">
                            <svg className="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                                </svg>
                            <a href={basename + "/lerneinheiten/page/" + pageTreeContextValue.pageNavigationInfo.subChapterID} className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2 dark:text-gray-400 dark:hover:text-white">
                                {pageTreeContextValue.pageNavigationInfo.subChapterName} 
                            </a>                        
                        </div>
                    </li>  
                }
                {
                    pageTreeContextValue.pageNavigationInfo.lerneinheitID !== pageTreeContextValue.currentPageID
                    && pageTreeContextValue.pageNavigationInfo.subChapterID !== pageTreeContextValue.currentPageID
                    &&
                    <li aria-current="page">
                        <div className="flex items-center">
                            <svg className="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                            </svg>
                            <a href={basename + "/lerneinheiten/page/" + pageTreeContextValue.currentPageID} className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2 dark:text-gray-400 dark:hover:text-white">
                            {pageTreeContextValue.pageNavigationInfo.leafPageName}
                            </a>
                        </div>
                    </li>

                }
            </ol>
        }
        </nav> }
        </div>
        

    )
}